export const FEATURE_NAMESPACE = 'feature.optimizer'
